/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './FoldersRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#createFolder
 */
export const CREATE_FOLDER_MUTATION_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_createFolder';
export const CREATE_FOLDER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_FOLDER_MUTATION_FIELD_NAME,
  args: ['folderName', 'enabledObjectTypeId', 'folderOriginId', 'parentFolderId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createFolderRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#createFolderWithMetadata
 */
export const CREATE_FOLDER_WITH_METADATA_MUTATION_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_createFolderWithMetadata';
export const CREATE_FOLDER_WITH_METADATA_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_FOLDER_WITH_METADATA_MUTATION_FIELD_NAME,
  args: ['createdByUserId', 'updatedByUserId', 'createdAt', 'lastModified', 'folderName', 'enabledObjectTypeId', 'folderOriginId', 'parentFolderId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.createFolderWithMetadataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#deleteFolder
 */
export const DELETE_FOLDER_MUTATION_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_deleteFolder';
export const DELETE_FOLDER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_FOLDER_MUTATION_FIELD_NAME,
  args: ['folderObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.deleteFolderRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#renameFolder
 */
export const RENAME_FOLDER_MUTATION_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_renameFolder';
export const RENAME_FOLDER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RENAME_FOLDER_MUTATION_FIELD_NAME,
  args: ['folderId', 'newName'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.renameFolderRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#moveFolder
 */
export const MOVE_FOLDER_MUTATION_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_moveFolder';
export const MOVE_FOLDER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MOVE_FOLDER_MUTATION_FIELD_NAME,
  args: ['folderId', 'newParentFolderId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.moveFolderRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#getOrderedFoldersInThePath
 */
export const GET_ORDERED_FOLDERS_IN_THE_PATH_QUERY_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_getOrderedFoldersInThePath';
export const GET_ORDERED_FOLDERS_IN_THE_PATH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ORDERED_FOLDERS_IN_THE_PATH_QUERY_FIELD_NAME,
  args: ['folderId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getOrderedFoldersInThePathRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#getFoldersByParentId
 */
export const GET_FOLDERS_BY_PARENT_ID_QUERY_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_getFoldersByParentId';
export const GET_FOLDERS_BY_PARENT_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FOLDERS_BY_PARENT_ID_QUERY_FIELD_NAME,
  args: ['parentFolderId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getFoldersByParentIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#getsFoldersByIds
 */
export const GETS_FOLDERS_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_getsFoldersByIds';
export const GETS_FOLDERS_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GETS_FOLDERS_BY_IDS_QUERY_FIELD_NAME,
  args: ['folderIds', 'enabledObjectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getsFoldersByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc#getFolders
 */
export const GET_FOLDERS_QUERY_FIELD_NAME = 'com_hubspot_framework_folders_rpc_FoldersRpc_getFolders';
export const GET_FOLDERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FOLDERS_QUERY_FIELD_NAME,
  args: ['parentFolderIds', 'enabledObjectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getFoldersRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});